module.exports = "/assets/thumbs-up-a886c072bc2073da9d8d7b3c14b942fa.svg";